import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { waLink, WA_MESSAGES } from "@/lib/whatsapp";

export default function FAQSection({ faqs }) {
  if (!faqs.length) return null;
  return (
    <section id="faq" className="section-pad bg-sand-200/50">
      <div className="container-x grid lg:grid-cols-5 gap-10 md:gap-12">
        <div className="lg:col-span-2">
          <p className="eyebrow">Questions?</p>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl text-forest leading-tight">Everything you want to know, answered.</h2>
          <p className="mt-4 text-ink-soft">Still unsure? <a href={waLink(WA_MESSAGES.general)} target="_blank" rel="noopener noreferrer" className="text-clay underline underline-offset-4">Message us on WhatsApp</a> — we reply within a few hours.</p>
        </div>
        <div className="lg:col-span-3">
          <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-sand-300">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-serif text-base md:text-lg text-forest hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink-soft leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
